import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
@Component({
    selector: 'checkout-change-section',
    templateUrl: './checkout-change-section.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class CheckoutChangeSectionComponent {
    @Input()
    sectionTitle?: string;
}
